// extracted by mini-css-extract-plugin
module.exports = {"tab-selector":"TabSelector_tab-selector__Pmlhb","tab-button":"TabSelector_tab-button__lQTfy","is-active":"TabSelector_is-active__9c7lD"};